import React, { createContext, useState } from 'react';

export const AffiliateContext = createContext();

export const AffiliateProvider = ({ children }) => {
  const [statusFilter, setStatusFilter] = useState([]);
  const [referrerPhoneFilter, setReferrerPhoneFilter] = useState([]);
  const [inviteePhoneFilter, setInviteePhoneFilter] = useState([]);
  const [sortOrder, setSortOrder] = useState('desc');
  const [filterBody, setFilterBody] = useState();

  return (
    <AffiliateContext.Provider
      value={{
        statusFilter,
        setStatusFilter,
        referrerPhoneFilter,
        setReferrerPhoneFilter,
        inviteePhoneFilter,
        setInviteePhoneFilter,
        sortOrder,
        setSortOrder,
        filterBody,
        setFilterBody,
      }}
    >
      {children}
    </AffiliateContext.Provider>
  );
};
